import React from 'react';
import { DEFAULT_COUNTRY_CODE } from '../../../utils/constants';
import DonationDirectDebitUK from './UK';
import DonationDirectDebitSEPA from './SEPA';

const DirectDebitForm = () => {
  if (DEFAULT_COUNTRY_CODE === 'GB') {
    return <DonationDirectDebitUK />;
  }

  return <DonationDirectDebitSEPA />;
};

export default DirectDebitForm;
